import { createSlice } from '@reduxjs/toolkit';
import {
  createAsyncAction,
  createAsyncReducerHandlers,
  asyncInitialState as initialState,
} from '../utils/async';

import { fetchIntercom as fetchIntercomApi } from '../../api/intercom';

export const fetchIntercom = createAsyncAction('fetch-intercom', fetchIntercomApi);

const intercomSlice = createSlice({
  name: 'intercom',
  initialState,
  reducers: {
    clearIntercom(state) {
      delete state.data;
    },
  },
  extraReducers: {
    ...createAsyncReducerHandlers(fetchIntercom),
  },
});

export const { clearIntercom } = intercomSlice.actions;

export const { reducer: intercom } = intercomSlice;
